// Some basic classes to deal with camera
import * as THREE from "three";

export var CameraManager = (function () {
    this.camera = null;
    this.shake = function () {
    };
    this.update = function () {
    }
});
// This should be used for calculating the properties of the scenes camera
export var CameraEngine = (function () {
    this.camera = null;
    this.farTopRight = null;
    this.farTopLeft = null;
    this.farBottomRight = null;
    this.farBottomLeft = null;

    this.nearTopRight = null;
    this.nearTopLeft = null;
    this.nearBottomRight = null;
    this.nearBottomLeft = null;

    this.lat = 0;
    this.lon = -90.0;
    this.phi = 0;
    this.theta = 0;

    this.target = new THREE.Vector3(0, 0, 0);
    this.lookAt = null;
    this.speedTurn = 5.0;
    this.speedMove = 10.0;

    this.moveCamera = function (direction) {
        if (direction === MoveDirection.RIGHT) {
            this.lon += this.speedTurn;
        }

        if (direction === MoveDirection.LEFT) {
            this.lon -= this.speedTurn;
        }

        if (direction === MoveDirection.FORWARD) {
            this.camera.translateZ( - (this.speedMove));
        }

        if (direction === MoveDirection.BACKWARD) {
            this.camera.translateZ( + (this.speedMove));
        }
        // Compute the direction we are "looking"
        this.lat = Math.max(- 85, Math.min(85, this.lat));
        this.phi = THREE.Math.degToRad(90 - this.lat);
        this.theta = THREE.Math.degToRad(this.lon);

        let targetPosition = this.target,
            position = this.camera.position;

        targetPosition.x = position.x + 100 * Math.sin(this.phi) * Math.cos(this.theta);
        targetPosition.y = position.y + 100 * Math.cos(this.phi);
        targetPosition.z = position.z + 100 * Math.sin(this.phi) * Math.sin(this.theta);
        this.camera.lookAt(targetPosition);
        this.target = targetPosition;
    };
    // this is only useful is we are managing the camera and not the player

    this.getPlayerPosition = function() {
        let direction = new THREE.Vector3();
        direction.subVectors( this.target, this.camera.position ) ;
        direction.normalize();
        direction.multiplyScalar(300.0);
        direction.add(this.camera.position);
        return direction;
    };

    this.positionCamera = function () {
        this.lat = Math.max(- 85, Math.min(85, this.lat));
        this.phi = THREE.Math.degToRad(90 - this.lat);
        this.theta = THREE.Math.degToRad(this.lon);

        let targetPosition = this.target,
            position = this.camera.position;

        targetPosition.x = position.x + 100 * Math.sin(this.phi) * Math.cos(this.theta);
        targetPosition.y = position.y + 100 * Math.cos(this.phi);
        targetPosition.z = position.z + 100 * Math.sin(this.phi) * Math.sin(this.theta);

        this.camera.lookAt(targetPosition);
        this.target = targetPosition;
    };
    // used to compute the farPlane (if we need it)
    this.compute = function (_camera) {
        this.camera = _camera;
        if (this.camera == null) {
            return;
        }
        let hFar = 2 * Math.tan(this.camera.fov * Math.PI / 180 / 2) * this.camera.far;
        let wFar = hFar * this.camera.aspect;

        this.farTopLeft = new THREE.Vector3(-wFar / 2, hFar / 2, -this.camera.far);
        this.farBottomRight = new THREE.Vector3(wFar / 2, -hFar / 2, -this.camera.far);
        this.farTopRight = new THREE.Vector3(wFar / 2, hFar / 2, -this.camera.far);
        this.farBottomLeft = new THREE.Vector3(-wFar / 2, -hFar / 2, -this.camera.far);

        //this.camera.updateMatrixWorld();
        this.farTopLeft.applyMatrix4(this.camera.matrixWorld);
        this.farBottomRight.applyMatrix4(this.camera.matrixWorld);
        this.farTopRight.applyMatrix4(this.camera.matrixWorld);
        this.farBottomLeft.applyMatrix4(this.camera.matrixWorld);

        let hNear = 2 * Math.tan(this.camera.fov * Math.PI / 180 / 2) * this.camera.near;
        let wNear = hNear * this.camera.aspect;

        this.nearTopLeft = new THREE.Vector3(-wNear / 2, hNear / 2, -this.camera.near);
        this.nearBottomRight = new THREE.Vector3(wNear / 2, -hNear / 2, -this.camera.near);
        this.nearTopRight = new THREE.Vector3(wNear / 2, hNear / 2, -this.camera.near);
        this.nearBottomLeft = new THREE.Vector3(-wNear / 2, -hNear / 2, -this.camera.near);

        this.nearTopLeft.applyMatrix4(this.camera.matrixWorld);
        this.nearBottomRight.applyMatrix4(this.camera.matrixWorld);
        this.nearTopRight.applyMatrix4(this.camera.matrixWorld);
        this.nearBottomLeft.applyMatrix4(this.camera.matrixWorld);
    }
});
